import en from './messages/en/all'
import sv from './messages/sv/all'
import de from './messages/de/all'
import es from './messages/es/all'
import it from './messages/it/all'
import fr from './messages/fr/all'
import pt from './messages/pt/all'

export default {
  en,
  sv,
  de,
  es,
  it,
  fr,
  pt
}